import { DialogBoundary, DialogTrigger } from "@suse-o11y/dialog";
import { isString } from "@suse-o11y/is-string";
import React from "react";

import { finishSentence } from "../../generic/stringUtils";
import { ErrorDetailsDrawer } from "../_drawer/_error-details-drawer";
import { useNotificationClose } from "../react/notification/use-notification-close";

export interface ErrorMessageProps {
	children: React.ReactNode;
	error?: unknown;
	onRetry?: VoidFunction;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ children, error, onRetry }) => {
	const closeNotification = useNotificationClose();

	return (
		<div className="space-x-1.5" data-testid="notification-read-more-message">
			<span>{isString(children) ? finishSentence(children) : children}</span>

			<DialogBoundary>
				<DialogTrigger className="link link-secondary">Read more</DialogTrigger>

				<ErrorDetailsDrawer error={error} />
			</DialogBoundary>

			{onRetry && (
				<button
					className="link link-secondary"
					onClick={() => {
						closeNotification();
						onRetry();
					}}
					type="button"
				>
					Retry
				</button>
			)}
		</div>
	);
};
